// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules_temp/ebook/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules_temp/ebook/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#kcQaADTRACKbUnKC5w2m > * {\n    pointer-events: auto;\n    cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./src/fe/icon-list.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":["#container > * {\n    pointer-events: auto;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "kcQaADTRACKbUnKC5w2m"
};
export default ___CSS_LOADER_EXPORT___;
